import React from "react";
import { AbsoluteFill } from "remotion";
import {
  TeenageEngineeringBot,
  ThinkpadTacticalBot,
} from "./components/AntiSlopHardwareMascots";
import { Sliders, Cpu, ShieldCheck } from "lucide-react";

export const AntiSlopMascotShowcase: React.FC = () => {
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#EFECE6", // Tactile warm industrial gray
        color: "#1C1917",
        fontFamily: "'Inter', sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "130px 60px 110px",
        boxSizing: "border-box",
      }}
    >
      {/* Background Micro Grid */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(28, 25, 23, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(28, 25, 23, 0.05) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
          pointerEvents: "none",
        }}
      />

      {/* Header Pill & Title */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
          zIndex: 10,
        }}
      >
        <div
          style={{
            backgroundColor: "#FFFFFF",
            border: "2.5px solid #1C1917",
            borderRadius: 999,
            padding: "8px 26px",
            boxShadow: "4px 4px 0px #1C1917",
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
          }}
        >
          <ShieldCheck size={18} color="#059669" />
          <span
            style={{
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: 20,
              fontWeight: 800,
              letterSpacing: 2,
              color: "#1C1917",
              textTransform: "uppercase",
            }}
          >
            ANTI-AI-SLOP HARDWARE ARCHITECTURE · 100% REMOTION
          </span>
        </div>

        <h1
          style={{
            fontFamily: "'Anton', 'Bebas Neue', sans-serif",
            fontSize: 68,
            letterSpacing: 1.5,
            lineHeight: 1.0,
            color: "#1C1917",
            margin: 0,
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          2 ARAH MASKOT HARDWARE ASLI
        </h1>
        <p
          style={{
            fontSize: 22,
            color: "#57534E",
            fontWeight: 600,
            margin: 0,
            textAlign: "center",
          }}
        >
          Nol neon glow lebay · Nol pipi blush kartun · 100% tekstur alat fisik
          nyata
        </p>
      </div>

      {/* 2 Massive Hardware Showcase Cards Side by Side */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 36,
          width: "100%",
          maxWidth: 960,
          zIndex: 10,
        }}
      >
        {/* CARD 1: TEENAGE ENGINEERING / BRAUN */}
        <div
          style={{
            backgroundColor: "#FAF9F5",
            border: "4px solid #1C1917",
            borderRadius: 36,
            padding: "30px 24px 26px",
            boxShadow: "10px 10px 0px #1C1917",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
          }}
        >
          {/* Badge */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              backgroundColor: "#E0E7FF",
              padding: "6px 16px",
              borderRadius: 999,
              border: "1.5px solid #3730A3",
            }}
          >
            <Sliders size={18} color="#3730A3" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 18,
                fontWeight: 800,
                color: "#312E81",
                letterSpacing: 1.5,
              }}
            >
              ARAH 1 · TEENAGE ENGINEERING
            </span>
          </div>

          <TeenageEngineeringBot size={280} />

          <div style={{ textAlign: "center", marginTop: 4 }}>
            <div
              style={{
                fontFamily: "'Space Grotesk', monospace",
                fontSize: 26,
                fontWeight: 800,
                color: "#1C1917",
              }}
            >
              OP-ZURA // MILLED RESIN
            </div>
            <p
              style={{
                fontSize: 16,
                color: "#57534E",
                fontWeight: 600,
                lineHeight: 1.4,
                margin: "6px 0 0",
              }}
            >
              Bodi keramik/bone doff, tombol putar warna LEGO di atas, layar
              GameBoy/Playdate E-Ink monokrom, dan kisi speaker mikro.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              gap: 8,
              backgroundColor: "#E7E5E4",
              padding: "6px 14px",
              borderRadius: 8,
              border: "1px solid #D6D3D1",
              fontSize: 13,
              fontFamily: "monospace",
              fontWeight: 700,
              color: "#292524",
            }}
          >
            <span>[DIETER RAMS]</span>
            <span>[PLAYDATE]</span>
            <span>[SYNTH BOT]</span>
          </div>
        </div>

        {/* CARD 2: THINKPAD TACTICAL / SONY PVM */}
        <div
          style={{
            backgroundColor: "#18181B",
            border: "4px solid #09090B",
            borderRadius: 36,
            padding: "30px 24px 26px",
            boxShadow: "10px 10px 0px #09090B",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
            color: "#FFFFFF",
          }}
        >
          {/* Badge */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              backgroundColor: "#27272A",
              padding: "6px 16px",
              borderRadius: 999,
              border: "1.5px solid #EF4444",
            }}
          >
            <Cpu size={18} color="#EF4444" />
            <span
              style={{
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: 18,
                fontWeight: 800,
                color: "#FCA5A5",
                letterSpacing: 1.5,
              }}
            >
              ARAH 2 · TACTICAL THINKPAD
            </span>
          </div>

          <ThinkpadTacticalBot size={280} />

          <div style={{ textAlign: "center", marginTop: 4 }}>
            <div
              style={{
                fontFamily: "'Space Grotesk', monospace",
                fontSize: 26,
                fontWeight: 800,
                color: "#FFFFFF",
              }}
            >
              THINK-ZURA // BASALT MATTE
            </div>
            <p
              style={{
                fontSize: 16,
                color: "#A1A1AA",
                fontWeight: 600,
                lineHeight: 1.4,
                margin: "6px 0 0",
              }}
            >
              Bodi carbon basalt doff, pentil merah ThinkPad TrackPoint, layar
              tabung CRT amber monitor Sony PVM, dan antena radio BNC.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              gap: 8,
              backgroundColor: "#27272A",
              padding: "6px 14px",
              borderRadius: 8,
              border: "1px solid #3F3F46",
              fontSize: 13,
              fontFamily: "monospace",
              fontWeight: 700,
              color: "#F59E0B",
            }}
          >
            <span>[TRACKPOINT RED]</span>
            <span>[AMBER CRT]</span>
            <span>[CYBERDECK]</span>
          </div>
        </div>
      </div>

      {/* Footer Pill */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          backgroundColor: "#FFFFFF",
          color: "#1C1917",
          padding: "16px 36px",
          borderRadius: 999,
          border: "2.5px solid #1C1917",
          boxShadow: "6px 6px 0px #1C1917",
          zIndex: 10,
        }}
      >
        <span
          style={{
            fontFamily: "'Space Grotesk', monospace",
            fontSize: 20,
            fontWeight: 800,
            color: "#059669",
          }}
        >
          TIKTOK @ZURA.AILAB
        </span>
        <span style={{ color: "#D6D3D1" }}>•</span>
        <span
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: 20,
            fontWeight: 800,
            letterSpacing: 1.5,
          }}
        >
          PILIH JIWA HARDWARE-NYA: TEENAGE ENGINEERING (KIRI) ATAU THINKPAD
          (KANAN)?
        </span>
      </div>
    </AbsoluteFill>
  );
};
